import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './PharmacyField.scss';
import BaseSearchDropdown from './BaseSearchDropdown';
import StatesDropDownList from './StatesDropDownList';
import Tag from './Tag';

export default class PharmacyField extends PureComponent {
    static propTypes = {
        statesLabel: PropTypes.string,
        onSearch: PropTypes.func.isRequired,
        value: PropTypes.array,
        note: PropTypes.any,
    };

    static defaultProps = {
        statesLabel: '',
        value: [],
        note: null,
    };

    constructor(props = {}) {
        super(props);

        this.state = {
            state: props.state,
        }
    }

    handleChangeState = ({target: {value}}) => {
        this.setState({state: value});
    };

    handleAddPharmacy = ({target: {value}}) => {
        const {onChange, value: oldValues} = this.props;

        if (typeof value !== 'object' || oldValues.filter(p => p.id === value.id).length) {
            return;
        }

        onChange({target: {value: [...oldValues, value]}});
    };

    handleSearch = (value, currentCount = 0) => {
        const {onSearch} = this.props;
        const {state} = this.state;

        onSearch({search: value, offset: currentCount, state})
    };

    handleDeletePharmacy = (pharmacyId) => {
        const {onChange, value: oldValues} = this.props;

        onChange({target: {value: oldValues.filter(({id}) => id !== pharmacyId)}});
    };

    render() {
        const {state} = this.state;
        const {
            onSearch,
            statesLabel,
            value,
            withNote,
            error,
            label,
            note,
            placeholder,
            ...restProps
        } = this.props;
        const labelClassName = classnames(styles.label, {[styles.error]: error, [styles.withNote]: withNote});
        return (
            <div className={styles.container}>
                <label className={labelClassName}>{label}</label>
                <div className={styles.fieldsWrapper}>
                    <StatesDropDownList
                        isFormElement
                        onChange={this.handleChangeState}
                        value={state}
                        multipleSelection={false}
                        canBeNotSelected={false}
                        label={statesLabel}
                        disabled={value.length >= 5}
                    />
                    <PharmacyDropdown
                        {...restProps}
                        onSearch={this.handleSearch}
                        onChange={this.handleAddPharmacy}
                        loadOnScroll={this.handleSearch}
                        hardSet={false}
                        autoClear
                        placeholder={placeholder}
                        minValueLengthToSearch={3}
                        disabled={value.length >= 5}
                    />
                </div>
                <div className={styles.tagsList}>
                    {value.map(selectedPharmacy => (
                        <Tag
                            key={selectedPharmacy.id}
                            value={selectedPharmacy.name}
                            id={selectedPharmacy.id}
                            onDelete={this.handleDeletePharmacy}
                        />
                    ))}
                </div>
                {note}
            </div>
        )
    }
}

class PharmacyDropdown extends BaseSearchDropdown {
    constructor(props) {
        super(props);
        this.formatter = ({name}) => name;
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/PharmacyField.jsx